$(window).on('load', () => {
	$('.swiper-button-next').click(function () {
		console.log('works');
	});

	$('.dealestate-accordion').click(function () {
		$(this).toggleClass('active');
	});

	$('.dealestate-slider .wp-block-column').click(function () {
		const index = $('.dealestate-slider .wp-block-column').index(this);
		$(this).siblings('.active').removeClass('active');
		$(this).addClass('active');

		$(this)
			.parent()
			.parent()
			.children('.wp-block-gallery')
			.children('.wp-block-image')
			.removeClass('active');

		$(this)
			.parent()
			.parent()
			.children('.wp-block-gallery')
			.children(`.wp-block-image:nth-child(${index + 1})`)
			.addClass('active');
	});

	const swiper = new Swiper('.swiper', {
		direction: 'horizontal',
		loop: true,

		autoplay: {
			delay: 5000,
		},

		simulateTouch: true,

		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
});
